<template>
    <div class="app-root" :class="{ 'has-chrome': $route.meta.chrome, 'nav-open': navOpen }">
        <LoaderOverlay v-if="$store.getters.loading" />
        <ToastHost />
        <ConfirmDialog />
        <!-- Chrome screens render the switcher inside the header; everywhere else it floats in the corner. -->
        <LanguageSwitcher v-if="!$route.meta.chrome" class="lang-switch-floating" />
        <template v-if="$route.meta.chrome">
            <AppHeader @toggle-nav="navOpen = !navOpen" />
            <!-- Mobile-only drawer backdrop (hidden on desktop, where the nav is a static sidebar). -->
            <div class="app-nav-backdrop" @click="navOpen = false"></div>
            <AppNav class="app-nav" @navigate="navOpen = false" />
            <main class="app-main">
                <router-view />
            </main>
        </template>
        <router-view v-else />
    </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue';
import AppNav from '@/components/AppNav.vue';
import ToastHost from '@/components/ToastHost.vue';
import LoaderOverlay from '@/components/LoaderOverlay.vue';
import ConfirmDialog from '@/components/ConfirmDialog.vue';
import LanguageSwitcher from '@/components/LanguageSwitcher.vue';
import { checkVersion } from '@/plugins/version.js';

export default {
    name: 'App',
    components: { AppHeader, AppNav, ToastHost, LoaderOverlay, ConfirmDialog, LanguageSwitcher },
    data() {
        return {
            navOpen: false,
            versionTimer: null
        };
    },
    watch: {
        // Any navigation closes the mobile drawer.
        $route() {
            this.navOpen = false;
        }
    },
    mounted() {
        // Hard-refresh the app when a new frontend version is deployed (checked now and periodically), the same
        // way the main app does.
        checkVersion();
        this.versionTimer = setInterval(checkVersion, 60000);
    },
    unmounted() {
        if (this.versionTimer) clearInterval(this.versionTimer);
    }
};
</script>
